<template>
    <transition>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <h4 style="margin: 0; padding: 8px 0 1.5rem 0;">User List</h4>
                        </div>
                        <div class="page-title-right float-right">
                            <ol class="breadcrumb m-0">
                                <li class="breadcrumb-item active">Users </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);">User List</a></li>

                            </ol>
                        </div>
                        <div class="page-title-right float-right ">

                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 ">
                    <div class="card">
                        <div class="card-body">
                            <div class="modal-header">
                                <h5 class="modal-title">User Details</h5>

                                <div class=" ">
                                    <a href="javascript:void(0);" class="dropdown-item text-warning"
                                        @click="edit(items)">
                                        <i class="mdi mdi-circle-edit-outline me-1"></i> Edit</a>
                                </div>
                            </div>
                            <div class="modal-body">
                                <div class="profile-container">
                                    <img :src="items.profile_image" v-if="items.profile_image" class="profile-image">
                                </div>
                                <div class="info-block personal-info">
                                    <h6>Personal Information</h6>
                                    <p><span>Name:</span> {{ items.name }}</p>
                                    <p><span>Email:</span> {{ items.email }}</p>
                                    <p><span>Phone:</span> {{ items.phone }}</p>
                                </div>
                                <div class="info-block bkash-info">
                                    <h6>Bank Information</h6>
                                    <p><span>Bank Name:</span> {{ items.user_details ? items.user_details.bank_name : ''
                                        }}</p>
                                    <p><span>Account Name:</span> {{ items.user_details ?
                                            items.user_details.account_name : '' }}</p>
                                    <p><span>Bank Number:</span> {{ items.user_details ?
                                            items.user_details.account_number : '' }}</p>
                                    <p><span>Bank Routing Number:</span> {{ items.user_details ?
                                            items.user_details.routing_number : '' }}</p>
                                    <p><span>Bank Branch Name:</span> {{ items.user_details ?
                                            items.user_details.branch_name : '' }}</p>
                                </div>
                                <div class="info-container ">
                                    <div class="info-block bkash-info col-md-6">
                                        <h6>Bkash Information</h6>
                                        <p><span>Bkash Name:</span> {{ items.user_details ?
                                            items.user_details.bkash_name : '' }}</p>
                                        <p><span>Bkash Account Number:</span> {{ items.user_details ?
                                            items.user_details.bkash_account_number : '' }}</p>
                                        <p><span>Bkash Account Type:</span> {{ items.user_details ?
                                            items.user_details.bkash_type : '' }}</p>
                                    </div>
                                    <div class="info-block nagad-info col-md-6">
                                        <h6>Nagad Information</h6>
                                        <p><span>Nagad Name:</span> {{ items.user_details ?
                                            items.user_details.nagad_name : '' }}</p>
                                        <p><span>Nagad Account Number:</span> {{ items.user_details ?
                                            items.user_details.nagad_account_number : '' }}</p>
                                        <p><span>Nagad Account Type:</span> {{ items.user_details ?
                                            items.user_details.nagad_type : '' }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modal User Add -->
            <Modal @close="toggleModal()" :modalActive="modalActive">
                <div class="modal-content scrollbar-width-thin">
                    <div class="modal-header">
                        <h5>User Manage</h5>
                        <button @click="toggleModal()" type="button" class="btn btn-default">X</button>
                    </div>
                    <form @submit.prevent="submitForm()" enctype="multipart/form-data">

                        <div class="modal-body">
                            <div class="row">
                                <!-- Left Column: Form Fields -->
                                <div class="col-md-8">
                                    <!-- Personal Information -->
                                    <div class="form-row">
                                        <div class="form-group mb-2">
                                            <label for="name">Name *</label>
                                            <input type="text" class="form-control border"
                                                @keypress="onkeyPress('name')" v-model="form.name" id="name"
                                                placeholder="User Name" autocomplete="off">
                                            <div class="invalid-feedback" v-if="errors.name">{{ errors.name[0] }}</div>
                                        </div>
                                        <div class="form-group mb-2">
                                            <label for="email">Email *</label>
                                            <input type="email" class="form-control border"
                                                @keypress="onkeyPress('email')" v-model="form.email" id="email"
                                                placeholder="User Email" autocomplete="off">
                                            <div class="invalid-feedback" v-if="errors.email">{{ errors.email[0] }}
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="form-group mb-2">
                                                <label for="phone">Phone *</label>
                                                <input type="text" class="form-control border"
                                                    @keypress="onkeyPress('phone')" v-model="form.phone" id="phone"
                                                    placeholder="Contact Number">
                                                <div class="invalid-feedback" v-if="errors.phone">{{ errors.phone[0] }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="form-group mb-2">
                                                <label for="password" v-if="isRequired">Password *</label>
                                                <label for="password" v-else>Password</label>
                                                <input type="password" class="form-control border"
                                                    @keypress="onkeyPress('password')" v-model="form.password"
                                                    id="password" placeholder="Password">
                                                <div class="invalid-feedback" v-if="errors.password">{{
                                            errors.password[0] }}</div>
                                            </div>
                                            <div class="form-group mb-2">
                                                <label for="confirm_password" v-if="isRequired">Confirm Password
                                                    *</label>
                                                <label for="confirm_password" v-else>Confirm Password</label>
                                                <input type="password" class="form-control border"
                                                    @keypress="onkeyPress('password_confirmation')"
                                                    v-model="form.password_confirmation" id="confirm_password"
                                                    placeholder="Confirm Password">
                                                <div class="invalid-feedback" v-if="errors.password_confirmation">{{
                                            errors.password_confirmation[0] }}</div>
                                            </div>
                                        </div>
                                        <!-- Profile Picture -->
                                        <div class="form-row">
                                            <div class="form-group mb-2">
                                                <label>Profile Picture (128x128)</label><br>
                                                <div class="fileinput fileinput-new" data-provides="fileinput"
                                                    style="position: relative">
                                                    <span class="btn btn-block btn-primary btn-file">
                                                        <span class="fileinput-new"><i class="fa fa-camera"></i> Choose
                                                            Icon</span>
                                                        <span class="fileinput-exists" style="display:none">Change
                                                            Icon</span>
                                                        <input type="file" name="profile_image" @change="onImageChange">
                                                    </span>
                                                </div>
                                                <div class="invalid-feedback" v-if="errors.profile_image">{{
                                            errors.profile_image[0] }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Right Column: Profile Picture Preview -->
                                <div class="col-md-4">
                                    <p>Profile Picture Preview</p>
                                    <img :src="imagePreview" v-if="imagePreview" width="200">
                                    <img :src="form.profile_image" v-if="!imagePreview && form.profile_image"
                                        width="200">
                                </div>
                            </div>

                            <div class="row">
                                <!-- Bank Information (left side) -->
                                <div class="col-md-6">
                                    <div class="form-row">
                                        <div class="form-group mb-2">
                                            <label for="bank_name">Bank Name</label>
                                            <input type="text" class="form-control border"
                                                v-model="form.user_details.bank_name" id="bank_name"
                                                placeholder="Bank Name">
                                        </div>
                                        <div class="form-group mb-2">
                                            <label for="account_name">Account Name</label>
                                            <input type="text" class="form-control border"
                                                v-model="form.user_details.account_name" id="account_name"
                                                placeholder="Account Name">
                                        </div>
                                        <div class="form-group mb-2">
                                            <label for="bank_number">Bank Number</label>
                                            <input type="text" class="form-control border"
                                                v-model="form.user_details.bank_number" id="bank_number"
                                                placeholder="Bank Number">
                                        </div>
                                        <div class="form-group mb-2">
                                            <label for="routing_number">Bank Routing Number</label>
                                            <input type="text" class="form-control border"
                                                v-model="form.user_details.routing_number" id="routing_number"
                                                placeholder="Routing Number">
                                        </div>
                                        <div class="form-group mb-2">
                                            <label for="branch_name">Bank Branch Name</label>
                                            <input type="text" class="form-control border"
                                                v-model="form.user_details.branch_name" id="branch_name"
                                                placeholder="Branch Name">
                                        </div>
                                    </div>
                                </div>

                                <!-- Bkash and Nagad Information + Profile Picture (right side) -->
                                <div class="col-md-5">
                                    <!-- Bkash Information -->
                                    <div class="form-row">
                                        <div class="form-group mb-2">
                                            <label for="bkash_name">Bkash Name</label>
                                            <input type="text" class="form-control border"
                                                v-model="form.user_details.bkash_name" id="bkash_name"
                                                placeholder="Bkash Name">
                                        </div>
                                        <div class="form-group mb-2">
                                            <label for="bkash_account_number">Bkash Account Number</label>
                                            <input type="text" class="form-control border"
                                                v-model="form.user_details.bkash_account_number"
                                                id="bkash_account_number" placeholder="Bkash Account Number">
                                        </div>
                                        <div class="form-group mb-2">
                                            <label for="bkash_type">Bkash Account Type</label>
                                            <input type="text" class="form-control border"
                                                v-model="form.user_details.bkash_type" id="bkash_type"
                                                placeholder="Bkash Account Type">
                                        </div>
                                    </div>

                                    <!-- Nagad Information -->
                                    <div class="form-row">
                                        <div class="form-group mb-2">
                                            <label for="nagad_name">Nagad Name</label>
                                            <input type="text" class="form-control border"
                                                v-model="form.user_details.nagad_name" id="nagad_name"
                                                placeholder="Nagad Name">
                                        </div>
                                        <div class="form-group mb-2">
                                            <label for="nagad_account_number">Nagad Account Number</label>
                                            <input type="text" class="form-control border"
                                                v-model="form.user_details.nagad_account_number"
                                                id="nagad_account_number" placeholder="Nagad Account Number">
                                        </div>
                                        <div class="form-group mb-2">
                                            <label for="nagad_type">Nagad Account Type</label>
                                            <input type="text" class="form-control border"
                                                v-model="form.user_details.nagad_type" id="nagad_type"
                                                placeholder="Nagad Account Type">
                                        </div>
                                    </div>

                                </div>
                            </div> 
                        </div>

                        <div class="modal-footer">
                            <button type="submit" class="btn btn-primary " :disabled="disabled">
                                <span v-show="isSubmit">
                                    <i class="fas fa-spinner fa-spin"></i>
                                </span>{{btn}}
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>
        </div>
    </transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "./../helper/Modal";
import { ref, onMounted } from "vue";
import Form from 'vform'
import axios from 'axios';

import Buttons from '@/components/Buttons.vue';
import Datatable from '@/components/Datatable.vue';
import Pagination from '@/components/Pagination.vue';
export default {
    name: 'User',
    components: {
        Modal,
        Buttons,
        Datatable,
        Pagination
    },
    props: {
        language: {
            type: Object,
            default: () => {
                return {
                    lengthMenu: null,
                    info: null,
                    zeroRecords: null,
                    search: null
                }
            },
        },
    },
    data() {
        return {
            base_url: this.apiUrl,
            loading: true,
            isSubmit: false,
            isRequired: true,
            showModal: false,
            editMode: false,
            disabled: false,
            assignDisabled: false,
            modalActive: false,
            assignModalActive: false,
            isAssignSubmit: false,
            errors: {},
            imagePreview: '',
            btn: 'Create',
            items: [],
            form: new Form({
                id: '',
                name: '',
                email: '',
                phone: '',
                password: '',
                password_confirmation: '',
                profile_image: '',
                user_details: { id: '', user_id: '', account_name: '', account_number: '', bank_name: '', bkash_account_number: '', bkash_name: '', bkash_type: '', branch_name: '', nagad_account_number: '', nagad_name: '', nagad_type: '', routing_number: '' }
            }),
            multiclasses: {
                clear: '',
                clearIcon: '',
            },
            isLoading: true,
        };
    },
    methods: {
        toggleModal: function () {
            this.modalActive = !this.modalActive;
            if (!this.modalActive) {
                this.editMode = false;
                this.isRequired = true;
                this.btn = 'Create';
            }
            this.errors = '';
            this.isSubmit = false;
            this.form.reset();
        },
        toggleAssignModal: function () {
            this.assignModalActive = !this.assignModalActive;
            if (!this.assignModalActive) {
                this.btn = 'Assign';
                this.assignform.reset();
            }
            this.errors = '';
            this.isAssignSubmit = false;
            // this.assignform.reset();  
        },
        edit: function (item) {
            console.log('item', item);
            this.btn = 'Update';
            this.editMode = true;
            this.isRequired = false;
            this.toggleModal();
            this.form.fill(item);
            console.log('item-form', this.form);
            this.imagePreview = '';
        },

        submitForm: function (e) {
            this.isSubmit = true;
            this.disabled = true;
            const formData = new FormData();
            formData.append('name', this.form.name);
            formData.append('email', this.form.email);
            formData.append('phone', this.form.phone);
            formData.append('password', this.form.password);
            formData.append('password_confirmation', this.form.password_confirmation);
            for (const key in this.form.user_details) {
                if (this.form.user_details.hasOwnProperty(key)) {
                    formData.append(`user_details[${key}]`, this.form.user_details[key]);
                }
            }
            
            if (this.imagePreview) {
                this.form.profile_image ? formData.append('profile_image', this.form.profile_image, this.form.profile_image.name) : '';
            }
            var postEvent = axios.post(this.base_url + '/profile-update', formData, this.headers); 
            postEvent.then(res => {
                this.isSubmit = false;
                this.disabled = false;
                if (res.status == 200) {
                    this.toggleModal();
                    this.fetchItems();
                    this.$toast.success(res.data.message);
                } else {
                    this.$toast.error(res.data.message);
                }
            }).catch(err => {
                this.isSubmit = false;
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if (err.response.status == 422) {
                    this.errors = err.response.data.errors
                }
            });
        },

        onImageChange(e) {
            this.form.profile_image = e.target.files[0]
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;

            this.createImage(files[0]);

        },
        createImage(file) {
            let reader = new FileReader();
            let vm = this;
            reader.onload = (e) => {
                vm.imagePreview = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        validation: function (...fiels) {
            var obj = new Object();
            var validate = false;
            for (var k in fiels) {     // Loop through the object  
                for (var j in this.form) {
                    if ((j == fiels[k]) && (!this.form[j])) {
                        obj[fiels[k]] = fiels[k].replace("_", " ") + ' field is required';  // Delete obj[key]; 
                        this.errors = { ...this.errors, ...obj };
                    } else {
                        validate = false;
                    }
                }
            }
            // var obj = new Object();
            // obj[fiels] = fiels.replace("_", " ")+' field is required';  
            // this.errors = {...this.errors, ...obj}; 
        },
        onkeyPress: function (field) {
            for (var k in this.errors) {     // Loop through the object
                if (k == field) {      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }
        },

        fetchHelperData() {
            axios.get(this.apiUrl + '/user-helper-data', this.headerjson)
                .then((response) => {
                    let data = response.data.data;
                    this.roles = response.data.data.roles;
                })
                .catch(errors => {
                    console.log(errors);
                })
                .finally((fres) => {
                    this.loading = false;
                });
        },
        fetchItems(url = this.apiUrl + '/user-profile') {
            axios.get(url, { headers: this.headerparams })
                .then((response) => {
                    this.items = response.data.user;
                    if(!response.data.user.user_details){
                    this.items.user_details = { id: '', user_id: '', account_name: '', account_number: '', bank_name: '', bkash_account_number: '', bkash_name: '', bkash_type: '', branch_name: '', nagad_account_number: '', nagad_name: '', nagad_type: '', routing_number: '' }
                    }
                })
                .catch(errors => {
                    console.log(errors);
                })
                .finally((fres) => {
                    this.loading = false;
                });
        },
    },
    created() {
        this.fetchHelperData();
        this.fetchItems();
    },
    destroyed() { },
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {}
}
</script>
<style scoped>
.info-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

.bkash-info,
.nagad-info {
    flex: 1;
    min-width: 0;
    /* Ensure blocks do not shrink below their content size */
}

@media (max-width: 768px) {
    .info-container {
        flex-direction: column;
    }
}

.card-body {
    position: relative;
    padding: 20px;
    background-color: #f9f9f9;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.modal-title {
    margin: 0;
    font-size: 1.25rem;
    font-weight: bold;
}

.btn-edit {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
}

.btn-edit:hover {
    background-color: #0056b3;
}

.profile-container {
    text-align: right;
    position: absolute;
    top: 20px;
    right: 20px;
}

.profile-image {
    border-radius: 8px;
    width: 100px;
    height: 100px;
    object-fit: cover;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.modal-body {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.info-block {
    background: #ffffff;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.info-block h6 {
    margin-top: 0;
    font-size: 1.1rem;
    color: #333;
}

.info-block p {
    margin: 5px 0;
    font-size: 16px;
    color: #333;
}

.info-block p span {
    font-weight: bold;
    color: #007bff;
}

.card-body {
    padding: 20px;
    background-color: #f9f9f9;
}

.modal-body {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

.row {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

.col-md-8,
.col-md-4 {
    flex: 1;
}

.col-md-8 {
    max-width: 66.66%;
}

.col-md-4 {
    max-width: 33.33%;
    text-align: center;
}

.form-row {
    margin-bottom: 15px;
}

.form-group {
    margin-bottom: 10px;
}

.form-group p {
    font-size: 16px;
    color: #333;
    margin: 0;
}

.form-group p span {
    font-weight: bold;
    color: #007bff;
}

img {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 900px
}

.outlet-assign.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 600px;
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}
</style>